import React from "react";
import { useNavigate } from "react-router-dom";
import { EmptyText, WordBreak } from "../common/CellText";
import LinkOutlined from "../image/LinkOutlined";

const LinkedWork = (props) => {
    const { linkedWorkList, emptyText, style } = props;
    const navigate = useNavigate();

    const renderTitle = (string) => {
        if (string) {
            if (string.length <= 100) return string;
            return <div>{string.substring(0, 100).concat("...")}</div>;
        }
    };
    return (
        <div>
            {linkedWorkList && linkedWorkList?.length > 0 ? (
                linkedWorkList.map((link) => (
                    <div key={link.code} style={style}>
                        <a
                            style={{
                                display: "flex",
                                color: "#0075FF",
                                alignItems: "baseline",
                                gap: 4,
                                textDecoration: "underline",
                                lineHeight: "20px",
                                textUnderlineOffset: 2,
                            }}
                            className="linked"
                            onClick={() =>
                                navigate(`/work/view/${link.code}`)
                            }
                        >
                            <span>
                                <LinkOutlined />
                            </span>
                            {WordBreak(renderTitle(link.title))}
                        </a>
                    </div>
                ))
            ) : (
                <EmptyText>{emptyText || "Không có."}</EmptyText>
            )}
        </div>
    );
};

export default LinkedWork;
